jQuery( function($) {
    $(document).ready( function() {
		$( '.customer-login .toggle-forgetfulness, .recover-password .toggle-forgetfulness' ).unbind();
		$( '.customer-login .toggle-forgetfulness' ).click(function(){
			$( '.recover-password' ).show();
			$( '.customer-login' ).hide();
		});
		$( '.recover-password .toggle-forgetfulness' ).click(function(){
          	window.location.replace("https://thefabricstoreonline.com/account/login");
			$( '.customer-login' ).show();
			$( '.recover-password' ).hide();
		});
    });
});